define('features/goodbye-scion',[
  'jquery',
  'lib/util/tda.config',
  'components/slicker',
], function (
  $,
  tdaConfig,
  Slicker
) {
  var gbscion = {
    addCanonicalLink: function () {
      var clink = 'https://www.buyatoyota.com/' + tdaConfig.site.context_url + '/scion';
      $('head').append('<link rel="canonical" href="' + clink + '" />');
    },

    init: function () {
      this.addCanonicalLink();
      var vehicles = [
        { model: 'Yaris iA', year: '2017', img: 'pathToImage', link: 'link' },
        { model: 'Toyota 86', year: '2017', img: 'pathToImage', link: 'link' },
        { model: 'Corolla', year: '2017', img: 'pathToImage', link: 'link' }
      ];

      try {
        var gbSlideShow = new Slicker({
          $slider: $('.models-slideshow .carousel-inner'),
          slickOptions: {
            mobileFirst: true,
            slide: '.gb-slideshow-item',
            slidesToShow: 1,
            dots: true,
            arrows: true,
            centerMode: true,
            centerPadding: '0px',
            autoplay: true,
            paddingBottom: '50px',
            initFunction: function() {
              $('.gb-slideshow.carousel').css('opacity', '1'); // IMPORTANT, OBSCURES SLIDES WHILE INITIALIZING.
              $('.gb-slideshow.carousel').css('visibility', 'visible'); // IMPORTANT, REVEALS ALL SLIDEWSHOW ITEMS.
            }
          }
        });
        window.bat.util.loader.hideLoader();
      } catch (error) {
        console.error(' GB SLIDESHOW ERROR :::', error);
      }
    }
  };

  return gbscion;
});

